import { API_BASE } from '../config/api';

export const jsonHeaders = {
  'Content-Type': 'application/json',
};

export const authHeaders = (token) => ({
  ...jsonHeaders,
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

export const normalizeEmail = (email) => (email || '').trim().toLowerCase();

export async function parseApiError(response) {
  const data = await response.json().catch(() => ({}));
  if (response.status === 429) {
    return data.error || 'Too many requests. Please try again later.';
  }
  if (response.status === 401) {
    return data.error || 'Unauthorized. Please sign in again.';
  }
  return data.error || data.message || `Request failed (${response.status})`;
}

export async function fetchUserStatus(email) {
  const response = await fetch(
    `${API_BASE}/users/status?email=${encodeURIComponent(normalizeEmail(email))}`,
    { headers: jsonHeaders }
  );

  if (!response.ok) {
    throw new Error(await parseApiError(response));
  }

  return response.json();
}

export async function loginUser(email, password) {
  const trimmedEmail = normalizeEmail(email);
  const response = await fetch(`${API_BASE}/users/login`, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ email: trimmedEmail, password }),
  });

  if (!response.ok) {
    return { ok: false, error: await parseApiError(response) };
  }

  const data = await response.json();
  return { ok: true, user: data.user, token: data.token };
}
